<template>
    <v-container fluid>
        <!--table head-->
        <v-row 
            class="my-2 subtitle-2 secondary--text pl-12">
            Segments & consumers' design preferences
        </v-row>
        <v-divider />
        <v-row class="subtitle-2" no-gutters>
            <v-col cols="2"></v-col>
            <v-divider vertical></v-divider>
                    
            <v-col cols="5" class="tabCell text-center">Consumers' design type preferences</v-col>
            <v-divider vertical></v-divider>
            <v-col cols="5" class="tabCell text-center">Consumers' design quality preferences</v-col>
        </v-row>
        <v-row class="subtitle-2 text-center" no-gutters>
            <v-col class="tabCell text-left" cols="2">Segment</v-col>
            <v-divider vertical></v-divider>
            <v-col  v-for="(item, i) in types" :key="`type-${i}`"
                class="tabCell"
                cols="1">
                {{ item }}
            </v-col>
            <v-divider vertical></v-divider>
            <v-col v-for="i in 5" :key="i"
                class="tabCell"
                cols="1">
                Level {{ i }}
            </v-col>
        </v-row>
        <div v-if="market_segments.length">
            <!--segments tab-->
            <v-row v-for="segment in market_segments" :key="segment.id" no-gutters>
                <v-col cols="2" class="tabCell text-left text-truncate">{{ segment.segment.name }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_classic }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_business }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_casual }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_innovative }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_art }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_1 }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_2 }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_3 }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_4 }}</v-col>
                <v-col class="tabCell text-center">{{ segment.design_5 }}</v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>

export default {
    name: 'MarketDesign',
    data() {
        return {
            types: ['Classic', 'Business', 'Casual', 'Innovative', 'Art'],
        }
    },
    computed: {
        market_segments() {
            return this.$store.getters.market_segments
        }
    },
    methods: {
    },
    components: {
        //changeDesign,
        //deleteSegment
    }
}
</script>